import RecurringProphyStudy from './studyConfig/RecurringProphyStudy'

export default new RecurringProphyStudy({
  molecule: 'Botox',
  smallText: 'e.g. Botox, Dysport, Vistabel',
  dosageOptions: [
    '50 units every 3 months',
    '155 units every 3 months',
    '400 units every 3 months'
  ]
})



// WEBPACK FOOTER //
// ./src/store/recurring/recurringProphyBotox.js